import { render } from "./Site.vue?vue&type=template&id=bf1981f0&scoped=true"
import script from "./Site.vue?vue&type=script&lang=js"
export * from "./Site.vue?vue&type=script&lang=js"

import "./Site.vue?vue&type=style&index=0&id=bf1981f0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1981f0"]])

export default __exports__